import { ILegalPersonInformationBaseViewModel } from 'viewModels';
import api from '../services/api/axios';

const getLegalPerson = (document: string) =>
  new Promise<ILegalPersonInformationBaseViewModel>((resolve) => {
    api
      .get(`informationbaselegalperson/${document}`)
      .then(({ data }) => resolve(data))
      .catch();
  });

const InformationBaseLegalPersonController = { getLegalPerson };

export default InformationBaseLegalPersonController;
